module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#news",
      toString: function () {
        return this.url;
      }
    }